import { render, staticRenderFns } from "./derate-manage-application.vue?vue&type=template&id=66de00d7"
import script from "./derate-manage-application.vue?vue&type=script&lang=ts"
export * from "./derate-manage-application.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports